module.exports = __webpack_public_path__ + "img/H3-2.png";